module.exports = __webpack_public_path__ + "assets/img/Compose_Folder.3d3a67f4.svg";